module.exports = __webpack_public_path__ + "assets/img/thumb-Nexon-4-Landing-Page.619ef087.jpg";